import { render, staticRenderFns } from "./_orderModal.vue?vue&type=template&id=42c3824d"
import script from "./_orderModal.vue?vue&type=script&lang=js"
export * from "./_orderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports